import React from 'react';
import { bool, func, node, string } from 'prop-types';

import { useConfiguration } from '../../context/configurationContext';
import { FormattedMessage } from '../../util/reactIntl';

import { AuthLayout, AuthMailIcon, AuthNote, NamedLink, PrimaryButton } from '../../components';

import css from './EmailVerificationInfo.module.css';

/**
 * "Check your email", shown on the sign-up page to a new user whose email isn't verified yet.
 */
const EmailVerificationInfo = props => {
  const {
    email,
    onResendVerificationEmail,
    resendErrorMessage,
    sendVerificationEmailInProgress,
  } = props;
  const config = useConfiguration();

  return (
    <AuthLayout
      top={<AuthMailIcon />}
      title={<FormattedMessage id="AuthenticationPage.verifyEmailTitle" />}
      subtitle={
        <FormattedMessage
          id="AuthenticationPage.verifyEmailText"
          values={{ email: <strong className={css.email}>{email}</strong> }}
        />
      }
    >
      {resendErrorMessage}
      <div className={css.actions}>
        <PrimaryButton
          type="button"
          onClick={onResendVerificationEmail}
          inProgress={sendVerificationEmailInProgress}
          disabled={sendVerificationEmailInProgress}
        >
          <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
        </PrimaryButton>
        <NamedLink name="ContactDetailsPage" className={css.changeEmail}>
          <FormattedMessage id="AuthenticationPage.changeEmail" />
        </NamedLink>
      </div>
      <AuthNote>
        <FormattedMessage
          id="AuthenticationPage.spamHint"
          values={{
            contactLink: (
              <a href={`mailto:${config.supportEmail}`}>
                <FormattedMessage id="AuthenticationPage.contactUs" />
              </a>
            ),
          }}
        />
      </AuthNote>
    </AuthLayout>
  );
};

EmailVerificationInfo.defaultProps = {
  email: null,
  resendErrorMessage: null,
};

EmailVerificationInfo.propTypes = {
  email: string,
  onResendVerificationEmail: func.isRequired,
  resendErrorMessage: node,
  sendVerificationEmailInProgress: bool.isRequired,
};

export default EmailVerificationInfo;
